import { cnsDirectiveFormatter } from "@/lib/mentions/cnsDirectiveFormatter";
import type { MentionReference } from "@/lib/mentions/types";

/**
 * Serializes a mention into assistant-ui directive wire text for composer and launch drain.
 * Uses {@link cnsDirectiveFormatter} so insert, parse, and render stay aligned.
 */
export function formatMentionDirective(mention: MentionReference): string {
  return cnsDirectiveFormatter.serialize({
    id: mention.id,
    type: mention.type,
    label: mention.label,
  });
}
